import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { Schemas } from 'vscode/vscode/vs/base/common/network';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { registerIcon } from 'vscode/vscode/vs/platform/theme/common/iconRegistry';
import { EditorInput } from 'vscode/vscode/vs/workbench/common/editor/editorInput';

const _moduleId = "vs/workbench/services/workspaces/browser/workspaceTrustEditorInput";
const WorkspaceTrustEditorIcon = registerIcon('workspace-trust-editor-label-icon', Codicon.shield, ( localizeWithPath(_moduleId, 0, 'Icon of the workspace trust editor label.')));
class WorkspaceTrustEditorInput extends EditorInput {
    constructor() {
        super(...arguments);
        this.resource = ( (URI.from({
            scheme: Schemas.vscodeWorkspaceTrust,
            path: `workspaceTrustEditor`
        })));
    }
    static { this.ID = 'workbench.input.workspaceTrust'; }
    get capabilities() {
        return 2  | 8 ;
    }
    get typeId() {
        return WorkspaceTrustEditorInput.ID;
    }
    matches(otherInput) {
        return super.matches(otherInput) || otherInput instanceof WorkspaceTrustEditorInput;
    }
    getName() {
        return ( localizeWithPath(_moduleId, 1, "Workspace Trust"));
    }
    getIcon() {
        return WorkspaceTrustEditorIcon;
    }
}

export { WorkspaceTrustEditorInput };
